import { defineStore } from 'pinia';
import { TopBar } from '@/types/topbar';

export const useTopbarStore = defineStore('topbar', {
  state: () => ({
    accessToken: '' as string,
    topBar: undefined as TopBar | undefined,
  }),
  getters: {
    isBusinessUser: (state): boolean => state.topBar?.isBusinessUser ?? false,
    ncpServiceUrl: (state): string => {
      const serviceUrl =
        state.topBar?.getUrlForService?.('ncp') ??
        'https://portal.postnord.com/skapa-utskick/v2/#/order/list';
      if (!serviceUrl) return serviceUrl;
      try {
        const urlObj = new URL(serviceUrl);
        const redirectionUrl = urlObj.searchParams.get('redirectionUrl');
        if (redirectionUrl) {
          const redirectUrlObj = new URL(redirectionUrl);
          const modifiedRedirectUrl = `${redirectUrlObj.origin}/skapa-utskick/v2/#/order/list`;
          urlObj.searchParams.set('redirectionUrl', modifiedRedirectUrl);
        }
        const modifiedUrl = urlObj.toString();
        console.log('ncpServiceUrl:', modifiedUrl);
        return modifiedUrl;
      } catch {
        console.log('ncpServiceUrl:', serviceUrl);
        return serviceUrl;
      }
    },
  },
  actions: {
    initTopbar() {
      const appWindow = window as Window & { pnTopbar?: TopBar };
      const onLoaded = () => {
        if (!appWindow.pnTopbar) return;
        this.accessToken = appWindow.pnTopbar.access_token ?? '';
        this.topBar = appWindow.pnTopbar;
        if (!appWindow.pnTopbar.isLoggedIn || appWindow.pnTopbar.isPrivateUser) {
          appWindow.pnTopbar.market = 'SE';
          appWindow.pnTopbar.markets = ['SE'];
        }
      };
      if (appWindow.pnTopbar?.hasLoaded) {
        onLoaded();
        return;
      }
      window.addEventListener('topbarLoaded', onLoaded, { once: true });
    },
    async getAccessToken(): Promise<string> {
      const appWindow = window as Window & { pnTopbar?: TopBar };
      if (appWindow.pnTopbar?.getAccessTokenAsync) {
        const freshToken = await appWindow.pnTopbar.getAccessTokenAsync();
        this.accessToken = freshToken;
        return freshToken;
      }
      return this.accessToken;
    },
  },
});
